import React from "react"
import { Link, useHistory, withRouter } from "react-router-dom"
import { useDispatch } from 'react-redux';
import styled from "styled-components";
import { signOutAction } from "../app/actions";
import { Button } from "react-bootstrap";

const SideBarConatiner = styled.div`
  background: darkblue;
  height: 100vh;
  min-width: 220px;
  padding: 1em;
`

const MenuLink = styled(Link)`
  display: block;
  padding: 1em;
  background: lightblue;
  margin-bottom: 8px;
  border-radius: 4px;
  white-space: nowrap;
`

const SideBar = () => {
    const dispatch = useDispatch()
    const history = useHistory()

    const signOut = () => {
        dispatch(signOutAction())
    }

    const tabs = [
        {
            to: "/dashboard",
            label: "Dashboard",
            active: history.location.pathname.includes("dashboard")
        },
        {
            to: "/tenants",
            label: "Tenants",
            active: history.location.pathname.includes("tenants") && !history.location.pathname.includes("tenant-list")
        },
        {
            to: "/users",
            label: "Users",
            active: history.location.pathname.includes("users")
        },
        // {
        //     to: "/user-tenant-connections",
        //     label: "User tenant connections",
        //     active: history.location.pathname.includes("user-tenant-connections")
        // },
        {
            divider: true
        },
        {
            to: "/languages",
            label: "Languages",
            active: history.location.pathname.includes("languages")
        },
        {
            to: "/feature-flags",
            label: "Feature flags",
            active: history.location.pathname.includes("feature-flags")
        }
    ]

    const activeTabStyle = {
        background: "#54d5f9"
    }

    return <SideBarConatiner>
        <Button onClick={signOut}>
            Sign out
        </Button>
        <div style={{paddingTop: "1em", paddingBottom:"2em", color: "white", fontSize: "2em", textAlign: "center"}}>
            MyGizmo
        </div>
        {tabs.map((tab, idx) => {
            if(tab.divider) {
                return <hr key={idx}/>
            } else {
                return <MenuLink key={idx} style={tab.active ? activeTabStyle : {}} to={tab.to}>{tab.label}</MenuLink>
            }
        })}
    </SideBarConatiner>
}

export default withRouter(SideBar)
